import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const ConvertTextToLanguageRenderer = ({ value, colDef, data }) => {
  const { t } = useTranslation();
  if (
    colDef?.cellRenderer === 'convertEventType' && // only convert if the eventType is systemRequired
    data?.systemRequired
  ) {
    return <span>{t(value)}</span>;
  } else if (
    colDef?.cellRenderer === 'convertEventType' &&
    !data?.systemRequired
  ) {
    return <span>{value}</span>;
  } // for everything else
  return <span>{t(value)}</span>;
};

ConvertTextToLanguageRenderer.propTypes = {
  value: PropTypes.string,
  colDef: PropTypes.object,
  data: PropTypes.object,
};
export default ConvertTextToLanguageRenderer;
